import { Controller } from "@hotwired/stimulus";
import grapesjs from "grapesjs";
import grapesJSMJML from "grapesjs-mjml";
import plugin from "grapesjs-preset-newsletter";
import ckeditor from "grapesjs-plugin-ckeditor";
import blocks from "grapesjs-blocks-basic";

export default class extends Controller {
  static targets = ["canvas", "blocks", "panels", "input"];

  editor = undefined;

  connect() {
    let editor = grapesjs.init({
      // Indicate where to init the editor. You can also pass an HTMLElement
      container: this.canvasTarget,
      // Get the content for the canvas directly from the element
      // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
      fromElement: true,
      // Size of the editor
      // Disable the storage manager for the moment
      storageManager: false,
      height: "100%",
      // Avoid any default panel
      plugins: [grapesJSMJML],
      pluginsOpts: {
        [grapesJSMJML]: {
          useCustomTheme: false,
          resetStyleManager: true,
        },
      },
      blockManager: {
        appendTo: this.blocksTarget,
      },

      panels: {
        defaults: [
          // ...
        ],
      },
      style: `
    [contenteditable="true"]:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  `,

      styleManager: {
        appendTo: ".styles-container",
      },
      traitManager: {
        appendTo: ".traits-container",
      },
    });

    let panelManager = editor.Panels;

    let panels = panelManager.getPanels().map((panel) => panel.id);
    panels.forEach((panel) => {
      panelManager.removePanel(panel);
    });

    this.editor = editor;

    this.editor.on("update", () => {
      this.updateInput();
    });

    this.updateInput();
  }

  updateInput() {
    let parser = new DOMParser();
    let dom = parser
      .parseFromString(this.editor.getHtml(), "text/html")
      .querySelector("mjml");

    let head = dom.querySelector("mj-head");

    if (!head) {
      head = document.createElement("mj-head");
      dom.insertAdjacentElement("afterbegin", head);
    }

    let style = head.querySelector("mj-style");

    if (!style) {
      style = document.createElement("mj-style");
      head.insertAdjacentElement("afterbegin", style);
    }

    style.innerHTML = this.editor.getCss();

    this.inputTarget.value = dom.outerHTML;
  }
}
